import React, { useState } from "react";
import axios from "axios";
import { Mail, X, Send } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const EmailVerificationBanner = ({ user }) => {
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  // Don't show if: no user, already verified, or dismissed for this session
  if (!user || user.email_verified || dismissed) return null;

  const handleResend = async () => {
    if (sending) return;
    setSending(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, { email: user.email });
      toast.success("Verification email sent. Check your inbox (and spam folder).");
    } catch (e) {
      // Anti-enumeration: backend always returns success-ish; treat error as send-OK from UX side
      toast.success("If your account is unverified, a new email was sent.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="bg-amber-500/10 border border-amber-500/40 border-l-4 border-l-amber-500 p-3 sm:p-4 flex items-start sm:items-center gap-3 flex-col sm:flex-row"
      data-testid="email-verification-banner"
    >
      <div className="flex items-start sm:items-center gap-3 flex-1">
        <Mail className="w-5 h-5 text-amber-400 mt-0.5 sm:mt-0 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-bold text-amber-200">Verify your email</p>
          <p className="text-xs text-amber-300/80">
            Check <span className="font-mono text-white">{user.email}</span> for the link. Didn't receive it?
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-auto">
        <button
          onClick={handleResend}
          disabled={sending}
          className="text-xs uppercase tracking-widest font-heading font-black bg-amber-600 hover:bg-amber-500 disabled:opacity-50 text-white px-3 py-2 transition-all flex items-center gap-1"
          data-testid="resend-verification-btn"
        >
          <Send className="w-3 h-3" /> {sending ? "Sending..." : "Resend"}
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-amber-400 hover:text-amber-200 p-1"
          aria-label="Dismiss"
          data-testid="dismiss-verification-banner-btn"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
